import { useTranslation } from "react-i18next";
import type { JSX } from "react";

export const Menu = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <svg
      aria-label={t("icons.menu")}
      fill="none"
      height={24}
      role="img"
      viewBox="0 0 24 24"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};

export default Menu;
